/* eslint-disable no-unused-vars */
import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { queryClient } from '@hc/utils';
import { httpRequest } from '@hc/utils/axios';
import { toast } from 'react-hot-toast';
import create from 'zustand';

export const useMasterFrequency = create((set, get) => ({
  masterFrequencyData: [],
  loading: null,
  error: null,
  getMasterFrequencyData: async () => {
    try {
      set({ loading: true });
      // For preventing duplicate request, we're using react-query

      const { data, status } = await queryClient.fetchQuery({
        queryKey: ['masterFrequency'],
        queryFn: async () => {
          const { data } = await httpRequest(
            'get',
            `${envConfig.api_url}/master/get-frequency`,
            {},
            true
          );
          return data;
        },
        staleTime: Infinity,
      });

      const masterFrequencyDataCopy = [];

      if (Array.isArray(data) && data?.length > 0) {
        data.map((val) => {
          masterFrequencyDataCopy.push({
            value: val?.id ?? '',
            name: val?.frequency ?? '',
            label: val?.frequency ?? '',
          });
        });
      }
      return set((state) => ({
        loading: false,
        masterFrequencyData: masterFrequencyDataCopy,
      }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
}));
